import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { GamePlayService } from 'src/app/game-play/gamePlayService.service';
import { TimerService } from 'src/app/timer/timerService.service';
import { LeaderBoardService } from '../leaderBoardService.service';

@Component({
  selector: 'app-new-player',
  templateUrl: './new-player.component.html',
  styleUrls: ['./new-player.component.scss']
})
export class NewPlayerComponent implements OnInit {

  @Input() game;
  name = "";
  score = 0;

  constructor(private leaderBoardService: LeaderBoardService, public gamePlayService: GamePlayService, private timerService: TimerService, private router: Router) { }

  ngOnInit(): void {
    this.score = this.gamePlayService.score.getValue();
  }

  // onSubmit(form: NgForm) {
  //   const time = this.timerService.getTime();
  //   const name = form.value.name;
  //   const score = this.gamePlayService.score.getValue();
  //   // console.log(this.game);

  //   this.leaderBoardService.addPlayer(name, score, time.time, time.total);
  //   this.router.navigate(['leader-board-list']);
  //   this.gamePlayService.resetGame();
  // }

  submit(el) {
    let backdrop = document.getElementById('backdrop');
    backdrop.classList.remove('go-in');
    backdrop.classList.add('go-out');
    // el.style.animation = 'scale-out-pop 0.7s forwards';
    el.classList.remove('scale-in-pop');
    el.classList.add('scale-out-pop');
    if (this.gamePlayService.addLeaderBoard) {
      const time = this.timerService.getTime();
      const name = this.name;
      const score = this.gamePlayService.score.getValue();
      this.leaderBoardService.addPlayer(name, score, time.time, time.total);
      setTimeout(() => {
        this.router.navigate(['leader-board-list']);
        this.gamePlayService.resetGame();
      }, 700);
    } else {
      setTimeout(() => {
        this.router.navigate(['/choose']);
        this.gamePlayService.resetGame();
      }, 700);
    }
  }
}
